import { Profile } from "common/api/interfaces"
import { RootState } from "store"

export const createUsersModule = ()=>{
    return {
        profileSelector: (state: RootState) => state.data.profile?.result as Profile
    }
}